import { render } from "./PagesList.vue?vue&type=template&id=7f57e108"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"

import "@/styles/profile/pages/pagesList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__